import styled from 'styled-components'

export const NoSurgicalOrder = styled.div`
  margin: 1rem 0;
`
